import { ReactElement } from 'react';
import { SelectComboBox } from '@sc/shared-ui';
import { COUNTRIES } from '../utility/countries';
import { useFieldContext } from './formContext';

const COUNTRY_OPTIONS = COUNTRIES.map((c) => ({
  label: c.name,
  value: c.code,
}));

export const CountryField = ({ label }: { label: string }): ReactElement => {
  const field = useFieldContext<string>();

  return (
    <SelectComboBox
      label={label}
      placeholder="Select your country"
      options={COUNTRY_OPTIONS}
      value={field.state.value}
      onChange={(code) => field.handleChange(code)}
      error={field.state.meta.errors.join(', ')}
    />
  );
};
